module.exports = __webpack_public_path__ + "static/footer-2708b2793024ee297b3b96fc1e48e703.png";